import React, { Component } from "react";
import { computed } from "mobx";
import { observer } from "mobx-react";
import PropTypes from "prop-types";
import { Button, Dropdown, Header, Menu, Message, Modal, Popup } from "semantic-ui-react";
import { withTranslation } from "react-i18next";
import "../styles/TourBulkActionMenu.less";

@observer
class TourBulkActionMenu extends Component {
  constructor(props) {
    super(props);

    this.state = {
      modalShow: false,
      isActive: false,
    };
  }

  @computed
  get showNoteOnlyPhotographerCanReactivateTour() {
    const { selectedTours } = this.props;

    // If there is at least one Tour of a Customer without the Urbanimmersive Group special pricing
    // Let's warn them, they might not be able to reactivate their tours
    for (let i = 0; i < selectedTours.length; i += 1) {
      if (!selectedTours[i].customerHasUrbanimmersiveGroupSpecialPricing) {
        return true;
      }
    }

    return false;
  }

  showModal = isActive => this.setState({ modalShow: true, isActive });

  hideModal = isActive => this.setState({ modalShow: false, isActive });

  render() {
    const { t, selectedTours, onBulkUpdateIsActiveCallback, validationErrorMessages } = this.props;
    const { modalShow, isActive } = this.state;

    return (
      <>
        <div className="tour-bulk-action-menu">
          <Menu>
            <Menu.Item>
              <Popup
                content={t("clientPanelMisc:noTourSelected")}
                disabled={selectedTours.length > 0}
                trigger={
                  <Dropdown text={`${t("activate")}/${t("deactivate")} (${selectedTours.length})`}>
                    <Dropdown.Menu>
                      <Dropdown.Item
                        disabled={selectedTours.length === 0}
                        icon="ban"
                        text={t("deactivate")}
                        onClick={() => this.showModal(false)}
                      />
                      <Dropdown.Item
                        disabled={selectedTours.length === 0}
                        icon="check circle"
                        text={t("activate")}
                        onClick={() => {
                          onBulkUpdateIsActiveCallback(true);
                        }}
                      />
                    </Dropdown.Menu>
                  </Dropdown>
                }
              />
            </Menu.Item>
          </Menu>
          {Object.values(validationErrorMessages).length > 0 && (
            <Message negative>
              <Message.List>
                <>
                  {Object.values(validationErrorMessages).map((validationErrorMessage, index) => (
                    // eslint-disable-next-line react/no-array-index-key
                    <Message.Item key={index}>{validationErrorMessage}</Message.Item>
                  ))}
                </>
              </Message.List>
            </Message>
          )}
        </div>
        <Modal open={modalShow}>
          <Header icon="remove" content={t("clientPanelMisc:deactivateTour")} />
          <Modal.Content>
            <p>{t("clientPanelMisc:areYouSureDeactivateTour")}</p>
            {this.showNoteOnlyPhotographerCanReactivateTour && (
              <p>{t("clientPanelMisc:noteOnlyPhotographerReactivateTour")}</p>
            )}
          </Modal.Content>
          <Modal.Actions>
            <Button color="green" inverted onClick={this.hideModal}>
              {t("no")}
            </Button>
            <Button
              color="red"
              inverted
              onClick={() => {
                onBulkUpdateIsActiveCallback(isActive);
                this.hideModal();
              }}
            >
              {t("yes")}
            </Button>
          </Modal.Actions>
        </Modal>
      </>
    );
  }
}

TourBulkActionMenu.propTypes = {
  t: PropTypes.func.isRequired,
  selectedTours: PropTypes.array.isRequired,
  onBulkUpdateIsActiveCallback: PropTypes.func.isRequired,
  validationErrorMessages: PropTypes.object.isRequired,
};

export default withTranslation()(TourBulkActionMenu);
